export function getdata(){
	var obj = {

			headDataI:[
				{
					title: "减税性质代码及名称",
					prop: "zzsxgm_3_x_0",
					width:"100px",
					custom:true,

				},
				{
					title: "栏次",
					prop: "grade",
					width:"60px",
					custom:true,
				},
				{
					title: "期初余额",
					prop: "zzsxgm_3_x_1",
					width:"",align:'right',
					children:[
						{
						title: "1",align:'right',
						prop: "zzsxgm_3_x_1",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期发生额",
					prop: "zzsxgm_3_x_2",
					width:"",align:'right',
					children:[
						{
						title: "2",align:'right',
						prop: "zzsxgm_3_x_2",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期应抵减税额",
					prop: "zzsxgm_3_x_3",
					width:"",align:'right',
					children:[
						{
						title: "3=1+2",align:'right',
						prop: "zzsxgm_3_x_3",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "本期实际抵减税额",
					prop: "zzsxgm_3_x_4",
					width:"",align:'right',
					children:[
						{
						title: "4≤3",align:'right',
						prop: "zzsxgm_3_x_4",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "期末余额",
					prop: "zzsxgm_3_x_5",
					width:"",align:'right',
					children:[
						{
						title: "5=3-4",align:'right',
						prop: "zzsxgm_3_x_5",
						custom:true,
						width:"",
						},
					]
				},
			],
			tableDataIX:[
				{
					title:"合计",
					grade:"1",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_2:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					grade:"2",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_5:true,
					zzsxgm_3_x_2: {
						cellCode:" zzsxgm_3_2_2",
						cellType:"1",
						cellVal:"0.00"
					},
					zzsxgm_3_x_4: {
						cellCode:" zzsxgm_3_2_4",
						cellType:"1",
						cellVal:"0.00"
					},
				},
				{
					grade:"3",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_5:true,
					zzsxgm_3_x_2: {
						cellCode:" zzsxgm_3_3_2",
						cellType:"1",
						cellVal:"0.00"
					},
					zzsxgm_3_x_4: {
						cellCode:" zzsxgm_3_3_4",
						cellType:"1",
						cellVal:"0.00"
					},
				},
				{
					grade:"4",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_5:true,
					zzsxgm_3_x_2: {
						cellCode:" zzsxgm_3_4_2",
						cellType:"1",
						cellVal:"0.00"
					},
					zzsxgm_3_x_4: {
						cellCode:" zzsxgm_3_4_4",
						cellType:"1",
						cellVal:"0.00"
					},
				},
				{
					grade:"5",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_5:true,
					zzsxgm_3_x_2: {
						cellCode:" zzsxgm_3_5_2",
						cellType:"1",
						cellVal:"0.00"
					},
					zzsxgm_3_x_4: {
						cellCode:" zzsxgm_3_5_4",
						cellType:"1",
						cellVal:"0.00"
					},
				},
				{
					grade:"6",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_5:true,
					zzsxgm_3_x_2: {
						cellCode:" zzsxgm_3_6_2",
						cellType:"1",
						cellVal:"0.00"
					},
					zzsxgm_3_x_4: {
						cellCode:" zzsxgm_3_6_4",
						cellType:"1",
						cellVal:"0.00"
					},
				},
			],
			headDataII:[
				{
					title: "",
					prop: "zzsxgm_3_x_0",
					width:"100px",
					custom:true,
				},
				{
					title: "栏次",
					prop: "grade",
					width:"60px",
					custom:true,
				},
				{
					title: "免征增值税项目销售额",
					prop: "zzsxgm_3_x_1",
					width:"",
					children:[
						{
						title: "1",
						prop: "zzsxgm_3_x_1",align:'right',
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税销售额扣除项目本期实际扣除金额",
					prop: "zzsxgm_3_x_2",
					width:"",
					children:[
						{
						title: "2",align:'right',
						prop: "zzsxgm_3_x_2",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "扣除后免税销售额",
					prop: "zzsxgm_3_x_3",
					width:"",
					children:[
						{
						title: "3=1-2",align:'right',
						prop: "zzsxgm_3_x_3",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税销售额对应的进项税额",
					prop: "zzsxgm_3_x_4",
					width:"",
					children:[
						{
						title: "4",align:'right',
						prop: "zzsxgm_3_x_4",
						custom:true,
						width:"",
						},
					]
				},
				{
					title: "免税额",
					prop: "zzsxgm_3_x_5",
					width:"",
					children:[
						{
						title: "5",align:'right',
						prop: "zzsxgm_3_x_5",
						custom:true,
						width:"",
						},
					]
				},
			],
			tableDataIXX:[
				{
					title:"合  计",
					grade:"7",
					disabledzzsxgm_3_x_1:true,
					disabledzzsxgm_3_x_2:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"出口免税",
					grade:"8",
					disabledzzsxgm_3_x_2:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"其中：跨境服务",
					grade:"9",
					disabledzzsxgm_3_x_2:true,
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"10",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"11",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"12",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"13",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"14",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"15",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				},
				{
					title:"",
					grade:"16",
					disabledzzsxgm_3_x_3:true,
					disabledzzsxgm_3_x_4:true,
					disabledzzsxgm_3_x_5:true
				}
			],

	}
	return obj
}
